const isWebColor = (color) => color === "currentcolor" || color === "currentColor" || color === "inherit" || color.startsWith("var(");
var isWebColor_default = isWebColor;
export {
  isWebColor_default as default
};
//# sourceMappingURL=index.js.map
